/**
 * @todo Remove this enum.
 *
 * @deprecated Use {@link EChannels} instead.
 */
export enum ECHANNELS {
  INSUMA = 1,
  DIADIA = 2,
}
export enum EChannels {
  INSUMA = 1,
  DIA_DIA = 2,
}
export enum EApplications {
  GENERAL = 3,
  WEB = 1,
  APP = 2,
}

export enum EImportFileType {
  EXCLUDE_CREDIT = 'EXCLUDE_CREDIT',
  NEXT_DAY_DELIVERY = 'NEXT_DAY_DELIVERY',
  PROMOTION_YAPE = 'PROMOTION_YAPE',
}
